import React from 'react';
import cx from 'classnames';
import { FormGroup, FormSelect, TextArea } from '~/components/form';
import { FileDrop } from '~/components';

const LegalInformationForm = ({state, fieldActions, className, readonly = false, legalDescriptionIsOptional = false }) => {
    const deeds = (state.values.request?.documents || [])
        // .filter(doc => doc.type === 'deed')
        .map(doc => ({ ...doc, file: { path: doc.name }}));

    return (
        <div className={cx(className, 'grid', 'grid-cols-12', 'grid-flow-row', 'gap-x-8', 'gap-y-4')}>
            <FormGroup
                label="Policy Year"
                readOnly={readonly}
                groupClassName="col-span-3 col-start-1"
                path='policyYear'
                // validator={val => /^[12]{1}[0-9]{3}$/.test(val) ? true }
                value={state.values.policyYear}
                error={state.errors.policyYear}
                {...fieldActions}
                validator={value => /^\d{4}$|^$/.test(value) ? true : 'Invalid policy year'}
            />
            <FormGroup
                label="Deed Year"
                readOnly={readonly}
                groupClassName="col-span-3"
                path='deedYear'
                // validator={val => /^[12]{1}[0-9]{3}$/.test(val) ? true : 'Invalid Year'}
                value={state.values.deedYear}
                error={state.errors.deedYear}
                {...fieldActions}
                validator={value => /^\d{4}$|^$/.test(value) ? true : 'Invalid deed year'}
            />
            <FormSelect
                label={`Legal Description ${legalDescriptionIsOptional ? '' : '*'}`}
                type='select'
                readOnly={readonly}
                options={state.values.legalDescriptionOptions}
                required={!legalDescriptionIsOptional}
                isClearable={false}
                groupClassName="col-span-6"
                path='legalDescription'
                value={state.values.legalDescription}
                error={state.errors.legalDescription}
                {...fieldActions}
            />
            {
                state.values.legalDescription.value == 'platted' && (
                    <React.Fragment>
                        <FormGroup
                            label="Plat Book"
                            readOnly={readonly}
                            groupClassName="col-span-3"
                            path='platBook'
                            value={state.values.platBook}
                            error={state.errors.platBook}
                            {...fieldActions} />
                        <FormGroup
                            label="Plat Page"
                            readOnly={readonly}
                            groupClassName="col-span-3"
                            path='platPage'
                            value={state.values.platPage}
                            error={state.errors.platPage}
                            {...fieldActions} />
                        <FormGroup
                            label="Lot"
                            readOnly={readonly}
                            groupClassName="col-span-6"
                            path='lot'
                            value={state.values.lot}
                            error={state.errors.lot}
                            {...fieldActions} />
                        <FormGroup
                            label="Subdivision"
                            readOnly={readonly}
                            groupClassName="col-span-6"
                            path='subdivision'
                            value={state.values.subdivision}
                            error={state.errors.subdivision}
                            {...fieldActions} />
                        <FormGroup
                            label="Block"
                            readOnly={readonly}
                            groupClassName="col-span-6"
                            path='block'
                            value={state.values.block}
                            error={state.errors.block}
                            {...fieldActions} />
                        <FormGroup
                            label="Section"
                            path='section'
                            readOnly={readonly}
                            groupClassName="col-span-6"
                            value={state.values.section}
                            error={state.errors.section}
                            {...fieldActions} />
                    </React.Fragment>
                )
            }
            {
                state.values.legalDescription.value == 'metesAndBounds' && (
                    <TextArea
                        type="textarea"
                        required={!legalDescriptionIsOptional}
                        readOnly={readonly}
                        label="Brief Legal Description"
                        name="metesAndBoundsDescription"
                        path='metesAndBoundsDescription'
                        value={state.values.metesAndBoundsDescription}
                        error={state.errors.metesAndBoundsDescription}
                        {...fieldActions}
                        groupClassName="col-span-12"
                        placeholder="Please provide deed book and page, acreage, and any street information" />
                )
            }
            <FileDrop
                files={state.values.files?.length > 0 ? state.values.files : deeds}
                readOnly={readonly}
                className='w-full h-24'
                groupClassName='col-span-12 col-start-1'
                onChange={files => fieldActions.onChange(files, 'files')}
                multiple
                heading='Attach Copy of Description or Deed'
                onRemove={(_, index) => {
                    const files = [...state.values.files];
                    files.splice(index, 1);
                    fieldActions.onChange(files, 'files');
                }}
            />
        </div>
    );
};

export default LegalInformationForm;